import React from 'react'
import TableTable from '../../../Components/table/tableTable'

const Tables = () => {
  return <TableTable />
}

export default Tables
